<template>
  <div
    class="c-outreach-contact-twitter-post-card"
    data-testid="outreach-contact-twitter-post-card"
    @click="openLink(engagementUrl(tweet.external_id))"
  >
    <div class="c-outreach-contact-twitter-post-card__header">
      <div class="c-outreach-contact-twitter-post-card__header-left">
        <img
          alt=""
          class="c-outreach-contact-twitter-post-card__header-left-profile-image"
          height="21"
          src="https://assets.streem.com.au/icons/twitter.svg"
          width="21"
        />
        <a
          class="c-outreach-contact-twitter-post-card__header-left-name"
          data-testid="tweet-link"
          :href="engagementUrl(tweet.external_id)"
          rel="noopener noreferrer"
          target="_blank"
          @click.stop
        >
          {{ twitterHandle }}
        </a>
        <span
          v-if="tweet.post_type === 'reply_tweet'"
          class="text-blue-grey"
        >
          <QIcon
            name="img:https://assets.streem.com.au/icons/comments.svg"
            size="10px"
          />
          {{ $t("outreach_contact_twitter_post_card.replied") }}
        </span>

        <span
          v-if="tweet.post_type === 're_tweet'"
          class="text-blue-grey"
        >
          <QIcon
            name="img:https://assets.streem.com.au/icons/reshare.svg"
            size="10px"
          />
          {{ $t("outreach_contact_twitter_post_card.retweeted") }}
        </span>

        <span
          v-if="tweet.post_type === 'quote_tweet'"
          class="text-blue-grey"
        >
          <QIcon
            name="img:https://assets.streem.com.au/icons/quoted.svg"
            size="10px"
          />
          {{ $t("outreach_contact_twitter_post_card.quoted") }}
        </span>
      </div>
      <TimeAgo
        class="text-blue-grey subtitle self-start"
        :date="tweet.scheduled_at"
      />
    </div>
    <div class="c-outreach-contact-twitter-post-card__post">
      <span>
        {{ tweet.content }}
      </span>

      <SocialMentionCardAttachedMedia
        :assets="media(tweet.platform_attachments, 'video')"
      />

      <SocialMentionCardAttachedMedia
        :assets="media(tweet.platform_attachments, 'photo')"
      />
    </div>
    <div class="c-outreach-contact-twitter-post-card__footer">
      <SocialMentionEngagementItem
        icon="likes"
        :model-value="tweet.metadata.likes"
        @click="openLink(engagementUrl(tweet.external_id, 'likes'))"
      />

      <SocialMentionEngagementItem
        icon="comments"
        :model-value="tweet.metadata.comments"
        @click="openLink(engagementUrl(tweet.external_id))"
      />

      <SocialMentionEngagementItem
        icon="reshare"
        :model-value="tweet.metadata.retweets"
        @click="openLink(engagementUrl(tweet.external_id, 'retweets'))"
      />

      <SocialMentionEngagementItem
        icon="quoted"
        :model-value="tweet.metadata.quotes"
        @click="
          openLink(engagementUrl(tweet.external_id, 'retweets/with_comments'))
        "
      />
    </div>
    <slot name="after" />
  </div>
</template>

<script>
import TimeAgo from "shared/components/core/various/TimeAgo.vue";
import SocialMentionCardAttachedMedia from "shared/components/SocialMentionCardAttachedMedia.vue";
import SocialMentionEngagementItem from "shared/components/SocialMentionEngagementItem.vue";
import { openLink } from "shared/helpers/external";

export default {
  name: "OutreachContactTwitterPostCard",
  components: {
    SocialMentionCardAttachedMedia,
    SocialMentionEngagementItem,
    TimeAgo,
  },
  props: {
    twitterHandle: {
      type: String,
      default: null,
    },
    tweet: {
      type: Object,
      required: true,
    },
    engagementUrl: {
      type: Function,
      required: true,
    },
  },
  methods: {
    openLink,
    media(attachments, type) {
      const media = [];

      attachments.forEach((attachment) => {
        if (type === "photo") {
          if (attachment.type === "photo") {
            media.push({
              type: "photo",
              thumbnail: attachment.url,
            });
          }
        } else if (["video", "animated_gif"].includes(attachment.type)) {
          media.push({
            type: attachment.type,
            thumbnail: attachment.preview_image_url,
            url: attachment.url,
            duration: attachment.duration_ms / 1000,
          });
        }
      });

      return media;
    },
  },
};
</script>

<style scoped lang="scss">
.c-outreach-contact-twitter-post-card {
  border: 1px solid var(--s-color-denim-3);
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 9px;
  color: var(--s-color-denim-9);
  cursor: pointer;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;
      column-gap: 10px;

      &-name {
        font-size: 14px;
        font-weight: 700;
        color: inherit;
        text-decoration: none;

        &:focus-visible {
          outline: 2px solid var(--s-color-primary);
          outline-offset: 2px;
          border-radius: 2px;
        }
      }

      &-profile-image {
        display: block;
        overflow: hidden;
        width: 21px;
        height: 21px;
        background-color: #e5eaef;
        border-radius: 50%;
        color: #e5eaef;
      }
    }
  }

  &__post {
    font-weight: 400;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  }
}
</style>
